import { isAlienCharacter } from './registry';

const getNumericValue = (value) => {
	if (typeof value === 'number') {
		return value;
	}

	if (typeof value === 'string') {
		const parsed = parseInt(value, 10);
		return Number.isNaN(parsed) ? 0 : parsed;
	}

	if (value && typeof value === 'object') {
		return value.value || 0;
	}

	return 0;
};

const findCharacterElement = (character, { key, labels = [] }) => {
	if (!character?.sections) {
		return null;
	}

	const normalizedLabels = labels.map((label) => label.toLowerCase());

	return character.sections
		.flatMap((section) => section.elements || [])
		.find((element) => {
			if (key && element?.key === key) {
				return true;
			}

			return normalizedLabels.includes(element?.label?.toLowerCase?.() || '');
		});
};

const getAlienActivePanicMetric = (character) => {
	const activePanicResult = Number(character?.systemState?.alien?.activePanicResult || 0);
	const activePanicEffectId = character?.systemState?.alien?.activePanicEffect?.id || null;

	if (!activePanicEffectId || activePanicResult < 7) {
		return null;
	}

	return {
		key: 'active_panic',
		kind: 'alienActivePanic',
		labelKey: 'cameraMetrics.alien.panic',
		value: activePanicResult,
		tone: activePanicResult >= 10 ? 'danger' : 'warning',
		icon: 'panic',
		editable: true,
		min: 7,
		max: 15,
		panicEffectId: activePanicEffectId,
	};
};

const getAlienCameraMetrics = (character) => {
	const stressElement = findCharacterElement(character, {
		key: 'nivel_de_tension',
		labels: ['Nivel de tensión', 'Nivel de tension'],
	});
	const vitalityElement = findCharacterElement(character, {
		key: 'vitalidad',
		labels: ['Vitalidad'],
	});
	const airElement = findCharacterElement(character, {
		key: 'aire',
		labels: ['Aire'],
	});
	const airValue = getNumericValue(airElement?.value);
	const activePanicMetric = getAlienActivePanicMetric(character);

	return [
		activePanicMetric,
		{
			key: 'stress',
			sourceKey: 'nivel_de_tension',
			sourceLabels: ['Nivel de tensión', 'Nivel de tension'],
			labelKey: 'cameraMetrics.alien.stress',
			value: getNumericValue(stressElement?.value),
			tone: 'warning',
			icon: 'stress',
			editable: true,
			min: 0,
			max: stressElement?.value?.max,
		},
		{
			key: 'vitality',
			sourceKey: 'vitalidad',
			sourceLabels: ['Vitalidad'],
			labelKey: 'cameraMetrics.alien.vitality',
			value: getNumericValue(vitalityElement?.value),
			tone: 'danger',
			icon: 'vitality',
			editable: true,
			min: 0,
			max: vitalityElement?.value?.max,
		},
		{
			key: 'air',
			sourceKey: 'aire',
			sourceLabels: ['Aire'],
			labelKey: 'cameraMetrics.alien.air',
			value: airValue,
			tone: airValue <= 0 ? 'danger' : airValue <= 2 ? 'warning' : 'neutral',
			icon: 'air',
			editable: true,
			min: 0,
		},
	].filter(Boolean);
};

export const getCharacterCameraMetrics = (character) => {
	if (!character) {
		return [];
	}

	if (isAlienCharacter(character)) {
		return getAlienCameraMetrics(character);
	}

	return [];
};
